export type TFactTrajectoryPoint = {
  stationId?: number | null;
  md?: number | null;
  inc?: number | null;
  azi?: number | null;
  azMag?: number | null;
  azTrue?: number | null;
  tvd?: number | null;
  tvdss?: number | null;
  ns?: number | null;
  we?: number | null;
  northing?: number | null;
  easting?: number | null;
  closure?: number | null;
  closureDirection?: number | null;
  vsec?: number | null;
  ahd?: number | null;
  dls?: number | null;
  rateTurn?: number | null;
  rateBuild?: number | null;
  mdDelta?: number | null;
  tvdDelta?: number | null;
  tfo?: number | null;
  mtf?: number | null;
  gtf?: number | null;
  comment?: string | null;
  typeTrajStation?: string | null;
};

export const FACT_TRAJECTORY_POINT_KEYS = [
  'stationId',
  'md',
  'mdDelta',
  'tvdDelta',
  'inc',
  'azi',
  'azMag',
  'azTrue',
  'tvd',
  'tvdss',
  'ns',
  'we',
  'northing',
  'easting',
  'dls',
  'tfo',
  'rateTurn',
  'rateBuild',
  'mtf',
  'gtf',
  'closure',
  'closureDirection',
  'vsec',
  'ahd',
  'comment',
  'typeTrajStation',
] as const satisfies ReadonlyArray<keyof TFactTrajectoryPoint>;

export type TrajectoryPlanOrFact = 'plan' | 'fact';

export type TGraphTrajectoryRole = 'main' | 'reference';
